/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, signal} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import template from './workspace-view-page.component.html';

import {
  buildWorkspaceGridsterOpts,
  initWorkspaceModel,
  setupWorkspaceWidgetDefaults
} from './workspace-commons';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {APP_SHARED} from '../common/app-shared';
import {GridsterWorkspaceComponent} from '../common/directives/gridster-workspace.component';
import {WorkspaceGridsterItemViewComponent} from './workspace-gridster-item.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, GridsterWorkspaceComponent, WorkspaceGridsterItemViewComponent],
  selector: 'adn-workspace-view-page',
  template
})
export class WorkspaceViewPageComponent {
  readonly workspace = signal<any>(null);

  @Input()
  set model(model: any) {
    if (!model) {
      this.workspace.set(null);
      return;
    }
    initWorkspaceModel(
      model,
      this.LocalUserPermissions.hasNetworkPermission('MANAGE_NETWORK_DASHBOARDS'),
      this.LocalNetworkProfile.isPureMarketplacePlatform()
    );
    setupWorkspaceWidgetDefaults(
      model.data.widgets,
      (key) => this.translate.instant(key),
      this.LocalNetworkProfile,
      this.adnTimeShifter
    );
    this.workspace.set(model);
  }

  gridsterOpts = buildWorkspaceGridsterOpts(false);

  constructor(
    private readonly translate: TranslateService,
    @Inject(AdnTimeShifterService) private readonly adnTimeShifter: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

}
